import iosImg from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import googleImg from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import databarinImg from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import annieImg from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import sensorImg from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import gsdImg from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import mscienceImg from '@/pages/intelligence/assets/svg/dataSource/mscience.svg';

/** 纯文本 options，供非 hook 场景按 value 反查展示文本。 */
export const GOOGLE_PLATFORM_OPTIONS_TEXT = [
  { value: 'appstore', text: 'App Store' },
  { value: 'googleplay', text: 'Google Play' },
];
export const DATA_SOURCE_OPTIONS_TEXT = [
  { value: 'appannie', text: 'data.ai' },
  { value: 'sensortower', text: 'Sensor Tower' },
];
export const DATA_SOURCE_OPTIONS_ALL_TEXT = [
  { value: 'ogdb', text: 'DataBrain' },
  ...DATA_SOURCE_OPTIONS_TEXT,
];

export const useFilterOptionList = (params: any = {}) => {
  const {
    formatMessage = () => console.log,
    segmentTooltip = () => console.log,
  } = params;

  const googlePlatformFilterOptions = [
    { text: 'App Store', value: 'appstore', img: iosImg },
    { text: 'Google Play', value: 'googleplay', img: googleImg },
  ];

  const dataBrainFilterOptions = [
    {
      text: 'DataBrain',
      value: 'ogdb',
      img: databarinImg,
      tip: formatMessage({ id: 'dbi_metric_databrain_info' }),
    },
  ];

  const dataSourceFilterOptions = [
    {
      text: 'data.ai',
      value: 'appannie',
      img: annieImg,
      tip: formatMessage({ id: 'dbi_metric_appannie_info' }),
    },
    {
      text: 'Sensor Tower',
      value: 'sensortower',
      img: sensorImg,
      tip: formatMessage({ id: 'dbi_metric_sensortower_info' }),
    },
  ];

  const dataSourceFilterOptionsAll = [
    ...dataBrainFilterOptions,
    ...dataSourceFilterOptions,
  ];

  const planOptionFilterOptions = [
    { value: 'All', text: formatMessage({ id: 'dbi_all' }) },
    {
      value: 'global initial launch',
      text: formatMessage({ id: 'dbi_global_initial_launch' }),
    },
    {
      value: 'new market entry',
      text: formatMessage({ id: 'dbi_new_market_entry' }),
    },
  ];

  const digitalSegmentFilterOptions = [
    { value: 'All', text: formatMessage({ id: 'dbi_segment_all' }) },
    {
      value: 'Full Game',
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_full_game_key' }),
        formatMessage({ id: 'dbi_segment_full_game' }),
      ),
    },
    {
      value: 'MTX',
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_MTX_key' }),
        formatMessage({ id: 'dbi_segment_MTX' }),
      ),
    },
    {
      value: 'DLC: All Other',
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_all_other_key' }),
        formatMessage({ id: 'dbi_segment_DLC_all_other' }),
      ),
    },
    {
      value: 'DLC: Expansion',
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_expansion_key' }),
        formatMessage({ id: 'dbi_segment_DLC_expansion' }),
      ),
    },
    {
      value: 'DLC: Content Pre-Purchase Pass',
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_content_pre_purchase_pass_key' }),
        formatMessage({ id: 'dbi_segment_DLC_content_pre_purchase_pass' }),
      ),
    },
    {
      value: 'DLC: Unlockable Content Pass',
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_unlockable_content_pass_key' }),
        formatMessage({ id: 'dbi_segment_DLC_unlockable_content_pass' }),
      ),
    },
    {
      value: 'Subscription',
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_subscription_key' }),
        formatMessage({ id: 'dbi_segment_subscription' }),
      ),
    },
  ];

  const cascaderSegmentFilterOptions = [
    {
      value: 'Full Game',
      source: 'gsd',
      img: gsdImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_full_game_key' }),
        formatMessage({ id: 'dbi_segment_full_game' }),
      ),
    },
    {
      value: 'In-Game Currency',
      source: 'gsd',
      img: gsdImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_in_game_currency_key' }),
        formatMessage({ id: 'dbi_segment_in_game_currency_key' }),
      ),
    },
    {
      value: 'Full Game',
      source: 'mscience',
      img: mscienceImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_full_game_key' }),
        formatMessage({ id: 'dbi_segment_full_game' }),
      ),
    },
    {
      value: 'DLC: All Other',
      source: 'mscience',
      img: mscienceImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_all_other_key' }),
        formatMessage({ id: 'dbi_segment_DLC_all_other' }),
      ),
    },
    {
      value: 'DLC: Expansion',
      source: 'mscience',
      img: mscienceImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_expansion_key' }),
        formatMessage({ id: 'dbi_segment_DLC_expansion' }),
      ),
    },
    {
      value: 'DLC: Unlockable Content Pass',
      source: 'mscience',
      img: mscienceImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_unlockable_content_pass_key' }),
        formatMessage({ id: 'dbi_segment_DLC_unlockable_content_pass' }),
      ),
    },
    {
      value: 'DLC: Content Pre-Purchase Pass',
      source: 'mscience',
      img: mscienceImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_content_pre_purchase_pass_key' }),
        formatMessage({ id: 'dbi_segment_DLC_content_pre_purchase_pass' }),
      ),
    },
    {
      value: 'Subscription',
      source: 'mscience',
      img: mscienceImg,
      text: segmentTooltip(
        formatMessage({ id: 'dbi_segment_subscription_key' }),
        formatMessage({ id: 'dbi_segment_subscription' }),
      ),
    },
  ];

  const multipleSegmentFilterOptions = [
    {
      value: 'Full Game',
      text: formatMessage({ id: 'dbi_segment_full_game_key' }),
      render: segmentTooltip(
        formatMessage({ id: 'dbi_segment_full_game_key' }),
        formatMessage({ id: 'dbi_segment_full_game' }),
      ),
    },
    {
      value: 'MTX',
      text: formatMessage({ id: 'dbi_segment_MTX_key' }),
      render: segmentTooltip(
        formatMessage({ id: 'dbi_segment_MTX_key' }),
        formatMessage({ id: 'dbi_segment_MTX' }),
      ),
    },
    {
      value: 'DLC: All Other',
      text: formatMessage({ id: 'dbi_segment_DLC_all_other_key' }),
      render: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_all_other_key' }),
        formatMessage({ id: 'dbi_segment_DLC_all_other' }),
      ),
    },
    {
      value: 'DLC: Expansion',
      text: formatMessage({ id: 'dbi_segment_DLC_expansion_key' }),
      render: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_expansion_key' }),
        formatMessage({ id: 'dbi_segment_DLC_expansion' }),
      ),
    },
    {
      value: 'DLC: Content Pre-Purchase Pass',
      text: formatMessage({
        id: 'dbi_segment_DLC_content_pre_purchase_pass_key',
      }),
      render: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_content_pre_purchase_pass_key' }),
        formatMessage({ id: 'dbi_segment_DLC_content_pre_purchase_pass' }),
      ),
    },
    {
      value: 'DLC: Unlockable Content Pass',
      text: formatMessage({
        id: 'dbi_segment_DLC_unlockable_content_pass_key',
      }),
      render: segmentTooltip(
        formatMessage({ id: 'dbi_segment_DLC_unlockable_content_pass_key' }),
        formatMessage({ id: 'dbi_segment_DLC_unlockable_content_pass' }),
      ),
    },
    {
      value: 'Subscription',
      text: formatMessage({ id: 'dbi_segment_subscription_key' }),
      render: segmentTooltip(
        formatMessage({ id: 'dbi_segment_subscription_key' }),
        formatMessage({ id: 'dbi_segment_subscription' }),
      ),
    },
  ];

  const engageLevelSegmentFilterOptions = [
    { value: 'all', text: formatMessage({ id: 'dbi_all' }) },
    { value: '0_2h', text: formatMessage({ id: 'dbi_segment_lte_2h' }) },
    { value: '2h', text: formatMessage({ id: 'dbi_segment_greater_2h' }) },
    // { value: '10h', text: formatMessage({ id: 'dbi_segment_greater_10h' }) },
    // { value: '20h', text: formatMessage({ id: 'dbi_segment_greater_20h' }) },
    { value: '50h', text: formatMessage({ id: 'dbi_segment_greater_50h' }) },
    // { value: '100h', text: formatMessage({ id: 'dbi_segment_greater_100h' }) },
    { value: '200h', text: formatMessage({ id: 'dbi_segment_greater_200h' }) },
    // { value: '2h', text: segmentTooltip('>2h', formatMessage({ id: 'dbi_segment_greater_2h' })) },
    // { value: '10h', text: segmentTooltip('>10h', formatMessage({ id: 'dbi_segment_greater_10h' })) },
    // { value: '20h', text: segmentTooltip('>20h', formatMessage({ id: 'dbi_segment__greater_20h' })) },
  ];

  const regionSegmentFilterOptions = [
    {
      value: 'global',
      text: formatMessage({ id: 'dbi_region_segment_global' }),
    },
    { value: 'na', text: formatMessage({ id: 'dbi_region_segment_na' }) },
    { value: 'chn', text: formatMessage({ id: 'dbi_region_segment_chn' }) },
    { value: 'asia', text: formatMessage({ id: 'dbi_region_segment_asia' }) },
    { value: 'we', text: formatMessage({ id: 'dbi_region_segment_we' }) },
    { value: 'ee', text: formatMessage({ id: 'dbi_region_segment_ee' }) },
    {
      value: 'others',
      text: formatMessage({ id: 'dbi_region_segment_others' }),
    },
  ];

  return {
    planOptionFilterOptions,
    digitalSegmentFilterOptions,
    multipleSegmentFilterOptions,
    engageLevelSegmentFilterOptions,
    regionSegmentFilterOptions,
    googlePlatformFilterOptions,
    dataBrainFilterOptions,
    dataSourceFilterOptions,
    dataSourceFilterOptionsAll,
    cascaderSegmentFilterOptions,
  };
};
